import { Dialog as KDialog } from "@king-design/vue";
import IamAuthorizationDialog from "../components/IamAuthorizationDialog.vue";
import IamClaimsDialog from "../components/IamClaimsDialog.vue";
import { verifyKceRole } from "../api";
import { addKceRole } from "../api/iam";
import { getRawErrorMessage, notifyError } from "../../../common/core/request";
import { openDialog } from "../../../common/utils/open-dialog";
import { ref } from "vue";
import { isAxiosError } from "axios";

export async function verifyRoleLoose(region: string, roleName: string | undefined | null) {
  if (!roleName) {
    return true;
  }

  return await verifyRole(region, roleName);
}

export async function verifyRole(region: string, roleName: string) {
  try {
    const res = await verifyKceRole({ Region: region, RoleName: roleName });
    res.data;
  } catch (e) {
    __DEV__ && console.error(`IamRole（${roleName}）`, e);
    return false;
  }
  return true;
}

export type DialogComponentType = typeof IamAuthorizationDialog;

export async function openIamDialog(
  resourceName: string,
  roleName: string,
  DialogComponent: DialogComponentType,
  ok?: (dialogRef: { showLoading: () => void; hideLoading: () => void }) => Promise<boolean>,
) {
  const dialogRef = ref();
  return openDialog(DialogComponent, {
    ref: dialogRef,
    open: true,
    resourceName,
    roleName,
    ok: () => {
      return ok?.(dialogRef.value);
    },
  });
}

// export function gotoIamRoleAuthorization(roleName: string, target = "_blank") {
//   const url = encodeURIComponent(window.location.toString());
//   // TODO: url
//   window.open(
//     `https://uc.console.ksyun.com/pro/iam/#/role/authorize?serviceName=kce2&roleNames=${roleName}&redirectUrl=${url}`,
//     target,
//   );
// }

export async function confirmAuthorization() {
  await KDialog.confirm({
    content: "是否完成 IAM 授权",
  });
}

export async function confirmClaims(region: string, roleName: string, rethrow = false) {
  try {
    await addKceRole({ Region: region, RoleName: roleName });
    return true;
  } catch (e) {
    if (isAxiosError(e)) {
      const msg = getRawErrorMessage(e) ?? "";
      if (msg.includes("AlreadyExists")) {
        return true;
      }
    }
    if (rethrow) {
      throw e;
    }
    notifyError("获取 IAM 授权", e);
    return false;
  }
}

const IGNORE_IAM_ROLE_FOR_DEV = __DEV__ && true;

export async function makeSureIamRole(
  region: string,
  resourceName: string,
  roleName: string | undefined | null,
  onConfirm?: (region: string, roleName: string) => Promise<any>,
  DialogComponent = IamClaimsDialog,
): Promise<boolean> {
  // 无 role name 不需要校验权限
  if (!roleName || IGNORE_IAM_ROLE_FOR_DEV) {
    return true;
  }

  const isValid = await verifyRole(region, roleName);

  if (isValid) {
    return true;
  }

  // 无权限，前往 IAM 授权
  try {
    return await openIamDialog(
      resourceName,
      roleName,
      DialogComponent,
      onConfirm
        ? async dialog => {
            dialog?.showLoading();
            try {
              return await onConfirm(region, roleName);
            } catch (e) {
              notifyError("授权", e);
              __DEV__ && console.error("onConfirm error", e);
              return false;
            } finally {
              dialog?.hideLoading();
            }
          }
        : undefined,
    );
  } catch (e) {
    return false;
  }

  // return await makeSureIamRole(region, resourceName, roleName, onConfirm, DialogComponent);
}
